import React, { useContext } from 'react';
import ScatterChartD3 from './ScatterChart.js';
import { CostBenchmarkContext } from '../../../contexts/costBenchmarkingContext.js';
import { LoaderContext } from '../../../contexts/loaderContext.js';
import DefaultBenchmarkEmptyState from './DefaultBenchmarkEmptyState.js';

const GraphicTab = () => {
  const { loading } = useContext(LoaderContext);
  const { filteredData } = useContext(CostBenchmarkContext);

  return (
    <div className="flexContainer alignVertically flexCenter fullWidth fullHeight">
      {loading ?
        <div />
        :
        !filteredData || !filteredData.length ?
          <DefaultBenchmarkEmptyState />
          :
          <ScatterChartD3 data={filteredData} uniqueId={'visible'} />
      }
    </div>
  );
};

export default GraphicTab;
